import { Box, IconButton, Typography, Checkbox, FormControlLabel, Collapse } from '@mui/material';
import { AddCircleOutline as AddIcon, DeleteOutline as DeleteIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useState } from 'react';
import { CustomButton, CustomTextField } from '../../../common/components';
import { MAX_PERIODS } from '../constants/projectedReportConstants';
import ProjectedReportActions from './ProjectedReportActions';
import { formatBankName } from '../../bank-movements/utils/formatters';

const ProjectedReportFilters = ({
  periods,
  onPeriodChange,
  onAddPeriod,
  onRemovePeriod,
  isMobile,
  resetFilters,
  handleGenerateReport,
  handleExportPdf,
  handleExportExcel,
  exportDisabled,
  isExporting,
  isExportingExcel,
  allBanks,
  selectedBanks,
  onBankToggle,
  onSelectAllBanks,
  onDeselectAllBanks
}) => {
  const [showBankFilters, setShowBankFilters] = useState(false);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <CustomButton
          variant="texr"
          startIcon={<AddIcon />}
          onClick={onAddPeriod}
          disabled={periods.length >= MAX_PERIODS}
          size="small"
        >
          Agregar periodo
        </CustomButton>
        <Box>
          <ProjectedReportActions
            onReset={resetFilters}
            onGenerate={handleGenerateReport}
            onExport={handleExportPdf}
            onExportExcel={handleExportExcel}
            exportDisabled={exportDisabled}
            isExporting={isExporting}
            isExportingExcel={isExportingExcel}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {periods.map((period, index) => (
          <Box
            key={period.id}
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 2,
              alignItems: isMobile ? 'flex-start' : 'center',
            }}
          >
            <Typography variant="body2" sx={{ minWidth: 90, mt: 2 }}>
              Periodo {index + 1}
            </Typography>
            <CustomTextField
              label="Desde"
              type="date"
              value={period.from}
              onChange={(event) => onPeriodChange(period.id, 'from', event.target.value)}
              shrinkLabel
              size="small"
              sx={{ maxWidth: 180 }}
            />
            <CustomTextField
              label="Hasta"
              type="date"
              value={period.to}
              onChange={(event) => onPeriodChange(period.id, 'to', event.target.value)}
              shrinkLabel
              size="small"
              sx={{ maxWidth: 180 }}
            />
            <IconButton
              color="error"
              size="small"
              onClick={() => onRemovePeriod(period.id)}
              disabled={periods.length === 1}
              title="Eliminar periodo"
              sx={{ mt: 1 }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Box>

      {allBanks && allBanks.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer',
              mb: 1,
            }}
            onClick={() => setShowBankFilters(!showBankFilters)}
          >
            <IconButton size="small" sx={{ transform: showBankFilters ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
              <ExpandMoreIcon />
            </IconButton>
            <Typography variant="body2" fontWeight="medium">
              Filtrar por bancos ({selectedBanks?.length || 0} de {allBanks.length} seleccionados)
            </Typography>
          </Box>
          <Collapse in={showBankFilters}>
            <Box sx={{ pl: 4, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                <CustomButton variant="text" onClick={onSelectAllBanks} size="small">
                  Seleccionar todos
                </CustomButton>
                <CustomButton variant="text" onClick={onDeselectAllBanks} size="small">
                  Deseleccionar todos
                </CustomButton>
              </Box>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))',
                  gap: 1,
                }}
              >
                {allBanks.map((bankName) => (
                  <FormControlLabel
                    key={bankName}
                    control={
                      <Checkbox
                        checked={selectedBanks?.includes(bankName) || false}
                        onChange={() => onBankToggle(bankName)}
                        size="small"
                      />
                    }
                    label={formatBankName(bankName)}
                  />
                ))}
              </Box>
            </Box>
          </Collapse>
        </Box>
      )}
    </>
  );
};

export default ProjectedReportFilters;
